import { type WorkerRequirement } from "@src/appV2/redesign/Documents/api/types";

interface IsPostBookingRequirementForShiftProps {
  requirement: WorkerRequirement;
  workplaceId: string;
  qualifications: string[];
}

export function isPostBookingRequirementForShift(
  props: IsPostBookingRequirementForShiftProps
): boolean {
  const { requirement, workplaceId, qualifications } = props;

  return (
    requirement.postBookingRequirementFor?.some(
      (entry) => entry.workplaceId === workplaceId && qualifications.includes(entry.qualification)
    ) ?? false
  );
}
